import React from 'react';
import { EmailSignature } from './components/EmailSignature';
import { EmailSignatureGuillaume } from './components/EmailSignatureGuillaume';
import { EmailSignatureZouhaier } from './components/EmailSignatureZouhaier';
import { EmailSignatureAmel } from './components/EmailSignatureAmel';
import { EmailSignatureKarim } from './components/EmailSignatureKarim';
import { EmailSignatureSameh } from './components/EmailSignatureSameh';
import { EmailSignatureSasa } from './components/EmailSignatureSasa';
import { EmailSignatureMontassar } from './components/EmailSignatureMontassar';
export function App() {
  return <div className="min-h-screen bg-gray-50 py-12" data-id="element-0">
      <div className="max-w-5xl mx-auto px-4" data-id="element-1">
        <div className="text-center mb-12" data-id="element-2">
          <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-3">
            Signatures Email IPcom
          </h1>
          <p className="text-gray-600" data-id="element-4">
            Signatures professionnelles pour l'équipe
          </p>
        </div>

        <div className="space-y-16" data-id="element-5">
          <div data-id="element-6">
            <h2 className="text-xl font-semibold text-gray-900 mb-6 text-center" data-id="element-7">
              Guillaume GIFFARD-CHOY - Ingénieur ECAM-EPMI
            </h2>
            <EmailSignatureGuillaume data-id="element-8" />
          </div>

          <div className="border-t-2 border-gray-300 pt-16" data-id="element-9">
            <h2 className="text-xl font-semibold text-gray-900 mb-6 text-center" data-id="element-10">
              Zouhaier GRISSA - Ingénieur ECAM-EPMI
            </h2>
            <EmailSignatureZouhaier data-id="element-11" />
          </div>

          <div className="border-t-2 border-gray-300 pt-16" data-id="element-12">
            <h2 className="text-xl font-semibold text-gray-900 mb-6 text-center" data-id="element-13">
              Amel JAOUANI - Responsable RH
            </h2>
            <EmailSignatureAmel data-id="element-14" />
          </div>

          <div className="border-t-2 border-gray-300 pt-16" data-id="element-15">
            <h2 className="text-xl font-semibold text-gray-900 mb-6 text-center" data-id="element-16">
              Karim AIT OUKHERAZ - Chargé d'affaires
            </h2>
            <EmailSignatureKarim data-id="element-17" />
          </div>

          <div className="border-t-2 border-gray-300 pt-16" data-id="element-18">
            <h2 className="text-xl font-semibold text-gray-900 mb-6 text-center" data-id="element-19">
              Saša JOVANOVIC - Chargé d'études
            </h2>
            <EmailSignatureSasa data-id="element-20" />
          </div>

          <div className="border-t-2 border-gray-300 pt-16" data-id="element-21">
            <h2 className="text-xl font-semibold text-gray-900 mb-6 text-center" data-id="element-22">
              Sameh BOUKADIDA - Conductrice travaux
            </h2>
            <EmailSignatureSameh data-id="element-23" />
          </div>

          <div className="border-t-2 border-gray-300 pt-16" data-id="element-24">
            <h2 className="text-xl font-semibold text-gray-900 mb-6 text-center" data-id="element-25">
              Montassar BOUGAMRA - Chargé d'affaires
            </h2>
            <EmailSignatureMontassar data-id="element-26" />
          </div>

          <div className="border-t-2 border-gray-300 pt-16" data-id="element-27">
            <h2 className="text-xl font-semibold text-gray-900 mb-6 text-center" data-id="element-28">
              Mehdi FATHALLAH - Agent IT
            </h2>
            <EmailSignature data-id="element-29" />
          </div>
        </div>

        <div className="mt-16 p-6 bg-blue-50 rounded-lg border border-blue-200" data-id="element-30">
          <h3 className="font-semibold text-gray-900 mb-3" data-id="element-31">
            Instructions d'installation
          </h3>
          <ol className="text-sm text-gray-700 space-y-2 ml-4 list-decimal" data-id="element-32">
            <li data-id="element-33">Choisissez votre signature</li>
            <li data-id="element-34">
              Copiez le code HTML de la signature depuis les paramètres de votre
              client email
            </li>
            <li data-id="element-35">
              <strong data-id="element-36">Outlook :</strong> Paramètres → Courrier → Rédaction et
              réponse → Signature email
            </li>
            <li data-id="element-37">
              <strong data-id="element-38">Gmail :</strong> Paramètres → Général → Signature → Créer
              une nouvelle signature
            </li>
          </ol>
        </div>
      </div>
    </div>;
}